var exports = {
  "Nr": "card__EKInQM",
  "rf": "body__EvKpkW",
  "wx": "header__A3YOFH",
  "R_": "heading__r-l09w",
  "r$": "logoContainer__ukUCtN",
  "wm": "logo__XrMsYg",
  "h_": "description__ksUAc_",
  "nf": "link__jGBs0K",
  "qr": "footer__Iw8UiV",
  "lu": "footerStats__I-8Mov",
  "rH": "footerOwner__Kl2T7K",
  "az": "isolate__gRAmIf",
};

module.exports = exports;
